<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);
</script>

<template>
  <div
    class="flow-node w-[180px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-orange-400' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />

    <div class="flex items-center gap-2 px-3 py-2 bg-orange-500 text-white">
      <span class="i-lucide-repeat size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ data.name || t('FLOW_BUILDER.NODES.FOR_EACH.TITLE') }}</span>
      <span
        v-if="audienceCount !== null"
        class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0"
      >
        {{ audienceCount }}
      </span>
    </div>

    <div class="px-3 py-2 bg-n-solid-1 text-n-slate-12 text-xs">
      <template v-if="data.variable_name">
        <span class="font-mono text-n-slate-11">{{ data.variable_name }}</span>
        <span v-if="data.max_iterations" class="text-n-slate-9">
          {{ ` · ${t('FLOW_BUILDER.NODES.FOR_EACH.MAX')} ${data.max_iterations}` }}
        </span>
      </template>
      <span v-else class="text-n-slate-9">{{ t('FLOW_BUILDER.NODES.FOR_EACH.CONFIGURE') }}</span>
    </div>

    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
